(function () {
  'use strict';

  const STYLE_ID = 'brilinton-shop-pay-typography';
  const MAX_FRAMES = 36;

  function formatQuarter(cents) {
    const amount = Number(cents) / 400;
    if (!Number.isFinite(amount)) return null;
    const currency = window.Shopify?.currency?.active || 'USD';
    try {
      return new Intl.NumberFormat(document.documentElement.lang || undefined, {
        style: 'currency',
        currency,
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(amount);
    } catch (_) {
      return `${amount.toFixed(2)} ${currency}`;
    }
  }

  function nativeNodes(host) {
    const root = host?.shadowRoot;
    if (!root) return null;
    return {
      root,
      content: root.querySelector('#shopify-installments-content'),
      cta: root.querySelector('#shopify-installments-cta'),
      logo: root.querySelector('#shopify-installments-content svg'),
    };
  }

  function hydrateMerch(host) {
    const nodes = nativeNodes(host);
    if (!nodes?.content || !nodes.content.textContent.trim()) return false;

    const wrapper = host.closest('.br-pdp-installment');
    const merch = wrapper?.querySelector('[data-shop-pay-merch]');
    if (!wrapper || !merch) return true;

    const amountNode = merch.querySelector('[data-shop-pay-merch-amount]');
    const formatted = formatQuarter(wrapper.dataset.shopPayPrice);
    if (amountNode && formatted) amountNode.textContent = formatted;

    const brand = merch.querySelector('[data-shop-pay-brand]');
    if (brand && nodes.logo && !brand.querySelector('svg')) {
      const clone = nodes.logo.cloneNode(true);
      clone.removeAttribute('class');
      clone.setAttribute('aria-hidden', 'true');
      brand.append(clone);
    }

    const info = merch.querySelector('[data-shop-pay-learn-more]');
    if (info && !info.dataset.bound) {
      info.dataset.bound = 'true';
      info.addEventListener('click', () => nativeNodes(host)?.cta?.click());
    }

    merch.hidden = false;
    return true;
  }

  function applyTypography(host) {
    if (!host) return false;
    const root = host.shadowRoot;
    if (!root) return false;

    if (!root.getElementById(STYLE_ID)) {
      const style = document.createElement('style');
      style.id = STYLE_ID;
      style.textContent = `
        #shopify-installments,
        #shopify-installments p,
        #shopify-installments span,
        #shopify-installments button {
          font-family: var(--font-body-family, Arial, sans-serif);
          letter-spacing: normal;
        }
        #shopify-installments .font-bold {
          font-family: var(--font-heading-family, var(--font-body-family, Arial, sans-serif));
          font-weight: 600;
        }
      `;
      root.append(style);
    }

    hydrateMerch(host);
    return true;
  }

  function styleHostWhenReady(host, frame) {
    if ((applyTypography(host) && hydrateMerch(host)) || frame >= MAX_FRAMES) return;
    requestAnimationFrame(() => styleHostWhenReady(host, frame + 1));
  }

  function syncAll() {
    document.querySelectorAll('shopify-payment-terms').forEach((host) => styleHostWhenReady(host, 0));
  }

  function updatePdpAmount(variant) {
    if (!variant || typeof variant.price !== 'number') return;
    document.querySelectorAll('.br-pdp-installment[data-shop-pay-price]').forEach((wrapper) => {
      wrapper.dataset.shopPayPrice = String(variant.price);
      const amountNode = wrapper.querySelector('[data-shop-pay-merch-amount]');
      const formatted = formatQuarter(variant.price);
      if (amountNode && formatted) amountNode.textContent = formatted;
    });
  }

  function scheduleSync() {
    requestAnimationFrame(() => requestAnimationFrame(syncAll));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleSync, { once: true });
  } else {
    scheduleSync();
  }

  if (window.customElements?.whenDefined) {
    customElements.whenDefined('shopify-payment-terms').then(scheduleSync).catch(() => {});
  }

  const bindPubSub = () => {
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return false;
    subscribe(PUB_SUB_EVENTS.cartUpdate, scheduleSync);
    subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
      updatePdpAmount(event?.data?.variant);
      scheduleSync();
    });
    return true;
  };

  if (!bindPubSub()) document.addEventListener('DOMContentLoaded', bindPubSub, { once: true });
  window.addEventListener('shopify:section:load', scheduleSync);
})();
